
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const SwitchView = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <polygon points="9.1 9.1 8 8 1.8 14.3 8 20.5 9.1 19.4 4.7 15 15.2 15 15.2 13.5 4.7 13.5 9.1 9.1"></polygon>
            <polygon points="17 4.5 15.9 5.6 20.3 10 9.8 10 9.8 11.5 20.3 11.5 15.9 15.9 17 17 23.2 10.7 17 4.5"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

SwitchView.defaultProps = {
  title: 'Switch View',
};

export default SwitchView;
